import UnderConstruction from "../../common/UnderConstruction";

import "./style.css";

function ErrorLog() {
    return (
        <div className="main-container" id="error-log">
            <UnderConstruction />
        </div>
    );
}

export default ErrorLog;
